import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.dce-express.fr';
const SITE_NAME = 'DCE Express';

export default function SEO({ 
  title, 
  description, 
  path = '/',
  type = 'website',
  image = '/og-image.png',
  noindex = false
}) {
  // Normalize path - remove trailing slash except for home
  const normalizedPath = path === '/' ? '' : path.replace(/\/$/, '');
  const fullUrl = `${SITE_URL}${normalizedPath}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Trouvez les Meilleurs Appels d'Offres avec l'IA`;
  const defaultDescription = "Trouvez les appels d'offres publics adaptés à votre entreprise grâce à l'Intelligence Artificielle. BOAMP, DECP, TED Europa - 6+ sources analysées.";
  const metaDescription = description || defaultDescription;
  const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  return (
    <Helmet prioritizeSeoTags>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE_NAME} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}
